import { render, staticRenderFns } from "./studentBulkCreate.vue?vue&type=template&id=719ca9f2&scoped=true&"
import script from "./studentBulkCreate.vue?vue&type=script&lang=ts&"
export * from "./studentBulkCreate.vue?vue&type=script&lang=ts&"
import style0 from "./studentBulkCreate.vue?vue&type=style&index=0&id=719ca9f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719ca9f2",
  null
  
)

export default component.exports